<template>
    <div v-if="playlists" class="w-full">
        <!-- Page Header -->
        <div class="bg-gradient-to-r from-nomad-800 to-nomad-900 rounded-lg overflow-hidden mb-8 p-6 md:p-8">
            <div class="text-center">
                <h1 class="text-white font-bold text-3xl md:text-5xl">Playlists</h1>
                <p class="text-nomad-300 mt-2">Curated collections of songs</p>
            </div>
        </div>

        <!-- Playlists Grid -->
        <ul class="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
            <li v-for="playlist in playlists.data" :key="playlist.id">
                <Link :title="playlist.name"
                    class="block p-4 rounded-lg bg-nomad-800 hover:bg-nomad-700 hover:shadow-lg transition-all duration-300 focus:outline-none"
                    :href="'/playlist/' + playlist.id">
                    <div class="text-center">
                        <h3 class="text-lg font-semibold text-white truncate mb-2">
                            {{ playlist.name }}
                        </h3>
                        <p class="text-md font-light text-nomad-300">
                            {{ playlist.songs_count }} {{ playlist.songs_count === 1 ? 'song' : 'songs' }}
                        </p>
                    </div>
                </Link>
            </li>
        </ul>
    </div>
</template>
<script setup>
defineProps({ playlists: Object });
</script>
<script>
import { defineAsyncComponent } from 'vue'
import { mapState, mapActions } from "vuex";
import { usePage, Link } from "@inertiajs/vue3";

export default {
    methods: {
        ...mapActions("playlists", ["getAllPlaylist"]),
    },
    beforeMount() {
        document.title = 'Playlists - Music Collection'
    },
    components: {
        'adsense': defineAsyncComponent(() => import("@/components/Adsense.vue")),
    }
};
</script>
